import BookingsSerializer from './base';

export default class Booking extends BookingsSerializer {}
